<template>
  <div id="registro">
    <v-app-bar app color="primary">
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text"></v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="exitApp">
        <v-icon color="white darken-2">mdi-close-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <v-container fluid style="margin-top: 5px;">
      <div align="center" style="margin-top: 0px;" class="mb-5">
        <v-img src="../../assets/logo.png" width="325px" height="125px"></v-img>
      </div>

      <v-row align="center" justify="center">
        <v-col cols="10" sm="8" md="4">
          <v-form @submit.prevent="onSubmit">
            <v-text-field
              label="Nombre"
              type="text"
              rounded
              outlined
              v-model="registerObj.name"
              :error-messages="nameErrors"
              @input="$v.registerObj.name.$touch()"
              @blur="$v.registerObj.name.$touch()"
            />

            <v-text-field
              label="Email"
              type="text"
              rounded
              outlined
              v-model="registerObj.email"
              :error-messages="emailErrors"
              @input="$v.registerObj.email.$touch()"
              @blur="$v.registerObj.email.$touch()"
            />

            <v-text-field
              label="Telefono/Celular"
              type="text"
              rounded
              outlined
              v-model="registerObj.phone"
              :error-messages="phoneErrors"
              @input="$v.registerObj.phone.$touch()"
              @blur="$v.registerObj.phone.$touch()"
            />

            <v-text-field
              label="Dirección"
              type="text"
              rounded
              outlined
              v-model="registerObj.direction"
              :error-messages="directionErrors"
              @input="$v.registerObj.direction.$touch()"
              @blur="$v.registerObj.direction.$touch()"
            />

            <v-text-field
              id="password"
              v-model="registerObj.password"
              label="Constraseña"
              name="password"
              append-icon="mdi-lock"
              type="password"
              rounded
              outlined
              :error-messages="passwordErrors"
              @input="$v.registerObj.password.$touch()"
              @blur="$v.registerObj.password.$touch()"
            />

            <v-text-field
              label="Re-ingresar Constraseña"
              type="password"
              rounded
              outlined
              v-model="registerObj.repeatPassword"
              :error-messages="repeatPasswordErrors"
              @input="$v.registerObj.repeatPassword.$touch()"
              @blur="$v.registerObj.repeatPassword.$touch()"
            />

            <div class="text-center">
              <v-btn
                color="primary"
                small
                class="ma-2"
                type="submit"
                dark
                rounded
                :loading="buttonLoading"
                >Registrar</v-btn
              >
              <v-btn color="primary" small dark rounded to="/login" class="ma-2"
                >Cancelar</v-btn
              >
              <!--   <br />
              <v-btn
                color="#946727"
                small
                dark
                rounded
                to="/register"
                class="ma-2"
                >Terminos y condiciones</v-btn
              > -->
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <Alert ref="Alert"></Alert>
  </div>
</template>
<script>
import Alert from "@/components/Reusable/Alert.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Register",
  mixins: [validationMixin],
  components: {
    Alert,
  },
  data() {
    return {
      buttonLoading: false,
      registerObj: {
        name: "",
        email: "",
        password: "",
        repeatPassword: "",
        phone: "",
        direction: "",
      },
    };
  },
  validations: {
    registerObj: {
      name: { required },
      email: { required, email },
      phone: { required },

      direction: { required },

      password: { required },
      repeatPassword: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.registerObj.name.$dirty) return errors;
      !this.$v.registerObj.name.required && errors.push("Campo es requerido.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.registerObj.email.$dirty) return errors;
      !this.$v.registerObj.email.email &&
        errors.push("Debe ser válido el correo electrónico");
      !this.$v.registerObj.email.required && errors.push("Correo es requerido");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.registerObj.phone.$dirty) return errors;
      !this.$v.registerObj.phone.required && errors.push("Campo es requerido.");
      return errors;
    },

    directionErrors() {
      const errors = [];
      if (!this.$v.registerObj.direction.$dirty) return errors;
      !this.$v.registerObj.direction.required &&
        errors.push("Campo es requerido.");
      return errors;
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.registerObj.password.$dirty) return errors;
      !this.$v.registerObj.password.required &&
        errors.push("Campo es requerido.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.registerObj.repeatPassword.$dirty) return errors;
      !this.$v.registerObj.repeatPassword.sameAsPassword &&
        errors.push("Campo debe ser igual ha contraseña");
      return errors;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
      } else {
        this.buttonLoading = true;

        const formData = {
          name: this.registerObj.name,
          email: this.registerObj.email,
          password: this.registerObj.password,
          cellPhone: this.registerObj.phone,
          direction: this.registerObj.direction,
        };
        this.$store
          .dispatch("register", formData)
          .then((response) => {
            this.buttonLoading = false;

            this.registerObj.name = "";
            this.registerObj.email = "";
            this.registerObj.password = "";
            this.registerObj.repeatPassword = "";
            this.registerObj.phone = "";
            this.registerObj.direction = "";

            this.$store.commit("showSnackbar", {
              text: "Registro realizado con éxito",
              color: "success",
            });

            this.$router.push("/login");
          })
          .catch((error) => {
            console.log(error.errors[0]);
            this.buttonLoading = false;
            this.$store.commit("showSnackbar", {
              text: error.errors[0],
              color: "error",
            });
            /*   if (error.errors.status == 5) {
              this.buttonLoading = false;
              this.$refs.Alert.open(
                "Información",
                "Correo o usuario ya registrado",
                { color: "#012269" }
              );
            }
            if (error.errors.status == 0) {
          

            
            } */
          });
      }
    },
    exitApp() {
      this.$router.push("/");
    },
  },
  mounted() {},
};
</script>
<style></style>
